module.exports = __webpack_public_path__ + "img/fund-4.72deb960.png";